import { render, staticRenderFns } from "./MiniReaction.vue?vue&type=template&id=ec6e5eda&"
import script from "./MiniReaction.vue?vue&type=script&lang=js&"
export * from "./MiniReaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports